<template>
  <div class="container-fluid">
    <div class="d-flex justify-content-between pb-3 align-items-center">
      <div>
        <div class="h3 font-weight-bold my-0">
          {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
        <div class="text-muted my-0">
          <span class="text-primary">Home</span> / Master Files / {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
      </div>
      <div>
        <button
          class="btn2 btn2-primary btn2-md mr-1 mb-3 mb-sm-0"
          @click="$refs.createTag.show()"
          v-if="role_modules.some(item => item.value == 'tag.create')"
        >
          <i class="uil-plus mr-1"></i> {{$t('tag.action.create_record')}}
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-xl-12">
      <Table
        ref="list"
        :useView="role_modules.some(item => item.value == 'tag.view')"
        :useEdit="role_modules.some(item => item.value == 'tag.edit')"
        :useDelete="role_modules.some(item => item.value == 'tag.delete')"
        noTitle
        :params="params"
        :fields="fields"
        :action="role_modules.some(item => item.value == 'tag') ? action : false"
        @openFormBar="openFormBar"
      />
      </div>
    </div>
    <Dialog
      centered
      title="View Tag"
      ref="viewTag"
      size="md"
      :component="viewComponent"
      :parameters="{ tagID, submitted }"
      v-if="role_modules.some(item => item.value == 'tag.view')"
    />
    <Dialog
      centered
      autoload
      is_reset_model
      title="Create Tag"
      ref="createTag"
      size="md"
      yesText="Create"
      noText="Cancel"
      :buttonDisable="created"
      :component="createComponent"
      @onYes="onCreateTag"
      v-if="role_modules.some(item => item.value == 'tag.create')"
    />
    <Dialog
      centered
      autoload
      title="Update Tag"
      ref="editTag"
      size="md"
      yesText="Update"
      noText="Cancel"
      :buttonDisable="updated"
      :component="editComponent"
      :parameters="{ tagID, submitted }"
      @onYes="onUpdateTag"
      v-if="role_modules.some(item => item.value == 'tag.edit')"
    />
    <Dialog
      centered
      autoload
      title="Delete Tag"
      ref="deleteTag"
      size="md"
      yesText="Delete"
      noText="Cancel"
      :buttonDisable="deleted"
      :component="deleteComponent"
      :parameters="{ id: tagID, submitted }"
      :module="'tag'"
      @onYes="onDeleteTag"
      v-if="role_modules.some(item => item.value == 'tag.delete')"
    />
  </div>
</template>

<script>
import Table from '@components/table'
import moment from 'moment/moment'
import Dialog from '@components/offcanvas'
import CreateComponent from './components/dialogs/create.vue'
import ViewComponent from './components/dialogs/view.vue'
import EditComponent from './components/dialogs/edit.vue'
import DeleteComponent from '@components/dialogs/delete.vue'

import error from '@utils/error'

export default {
  components: {
    Table,
    Dialog
  },
  computed: {
    createComponent () {
      return CreateComponent
    },
    viewComponent () {
      return ViewComponent
    },
    editComponent () {
      return EditComponent
    },
    deleteComponent () {
      return DeleteComponent
    }
  },
  data() {
    return {
      fields: [
				{
          label: this.$t('tag.table.name'), 
          key:"name",
          sortable: true
        },
        {
          label: this.$t('tag.table.date_created'), 
          key:'date_created', formatter: (val) => moment(val).format('YYYY-MM-DD')
        },
        {
          key:'actions',
          label:''
        }
      ],
      params: {},
      action: 'tag/pagination',
      tagID: '',
      submitted: false,
      created: false,
      updated: false,
      deleted: false,
    }
  },
  methods: {
    openFormBar(id, editMode = false, deleteMode = false) {
      this.tagID = id
      if (deleteMode) {
        this.$refs.deleteTag.show()
      } else if(!editMode){
        this.$refs.viewTag.show()
      }else{
        this.$refs.editTag.show()
      }
    },
    
    onCreateTag(val) {
      this.created = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val

      val.validateForm && val.validateForm()
      if (val.$v && val.$v.$error) {
        this.created = false;
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      }

      return this.$store.dispatch('tag/create', { ...model })
      .then(res => {
        if (res && res.data) {
          this.$refs.list.fetchData();
          this.$refs.createTag.hide();
          this.$bvToast.toast('Tag successfully created!', {
            title: "Notification",
            variant: "success"
          });
          setTimeout(() => {
            this.created = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.created = false;
        return error.errorHandler(err, this.$bvToast);
      })
    },
    onUpdateTag(val) {
      this.updated = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val
      model.id = model._id ? model._id : model.id ? model.id : ''

      val.validateForm && val.validateForm()
      if (val.$v && val.$v.$error) {
        this.updated = false;
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      }

      return this.$store.dispatch('tag/update', { ...model })
      .then(res => {
        if (res && res.data) {
          this.$refs.list.fetchData()
          this.$refs.editTag.hide()
          this.submitted = !this.submitted
          this.$bvToast.toast(`Tag successfully updated!`, {
            title: "Notification",
            variant: 'success'
          })
          setTimeout(() => {
            this.updated = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.updated = false;
        return error.errorHandler(err, this.$bvToast);
      })
    },
    onDeleteTag(val) {
      this.deleted = true;
      let id = val && val.model && val.model._id ? val.model._id : 
               val && val.model && val.model.id ? val.model.id :
               val && val.id ? val.id : 
               val && val._id ? val._id : 
               this.tagID;
      
      if (!id) {
        this.deleted = false;
        return;
      }

      return this.$store.dispatch('tag/delete', { id })
      .then(res => {
        if (res && res.data) {
          this.$refs.list.fetchData()
          this.$refs.deleteTag.hide()
          this.submitted = !this.submitted
          this.$bvToast.toast(`Tag successfully deleted!`, {
            title: "Notification",
            variant: 'success'
          })
          setTimeout(() => {
            this.deleted = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.deleted = false;
        return error.errorHandler(err, this.$bvToast);
      })
    }
  }
}
</script>